import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'megastore-admin-commission-handling',
  templateUrl: './commission-handling.component.html',
  styleUrls: ['./commission-handling.component.scss']
})
export class CommissionHandlingComponent {
  submitted = false;
  commissionHandlingForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<CommissionHandlingComponent>,
    private formBuilder: FormBuilder
  ) {
    this.commissionHandlingForm = this.formBuilder.group({
      adminCommission: ['', [Validators.required, Validators.max(100)]]
    });
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

  preventPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.commissionHandlingForm.valid) {
      this.dialogRef.close(
        this.commissionHandlingForm.get('adminCommission')?.value
      );
    }
  }
}
